import { useMutation, useQueryClient } from "@tanstack/react-query";

//** Axios request */
import { request } from "../../utilities/axios-utils.js";

//----------------------------------------------------------------
const putUpgradePolicy = async (requestData) => {
  if (requestData == null) {
    return;
  }

  const {
    policyNumber,
    accessToken,
    upgradeAccepted = true,
  } = { ...requestData };

  try {
    const response = await request({
      url: `/upgradePolicy/${policyNumber}?upgradeAccepted=${upgradeAccepted}`,
      method: "PUT",
      accessToken: accessToken,
    });
    return response;
  } catch (error) {
    console.log("Upgrade Policy error ", error);
  }
};

export const useUpgradePolicyMutation = () => {
  const queryClient = useQueryClient();
  //
  return useMutation({
    mutationFn: (data) => {
      return putUpgradePolicy(data);
    },
    onSuccess: (data) => {
      return data;
    },
    onError: async (err) => {
      console.log("Error", err);
    },
  });
};
